import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { getClientList } from 'store/clientSlice';
import { getVendorBillDetailsV2 } from 'store/vendorBillSliceV2';
import { getUIVersion } from 'utils/router-static-data';
import { Box, Text } from 'atoms';
import { Tabs } from 'atoms/Tabs';
import VendorBillTripsTab from './VendorBillTripsTab';
import InvoiceDetailsContent from './InvoiceDetailsContent';
// import { VendorBillGenerationForm } from 'components/forms';
// import { AdhocTripTableConfig, RegularTripTableConfig, NoLoadTripTableConfig } from 'utils';
// import { RCTable } from 'components';
// import { getListAction } from 'store/pageSlice';

const Container = styled(Box)`
	background-color: #f4f4f4;
	padding: 24px;
	font-weight: 300;
`;
const StyledTabs = styled(Tabs)`
	.ant-tabs-nav {
		margin-bottom: 16px;
	}

	.ant-tabs-tab {
		padding: 8px 16px;
		font-size: 14px;
		font-weight: 500;
	}

	.ant-tabs-tab-active {
		.ant-tabs-tab-btn {
			color: #18405d;
			font-weight: 600;
		}
	}

	.ant-tabs-ink-bar {
		background-color: #18405d;
		height: 2px;
	}
`;

const columnsRegularTrip = [
	{
		title: 'Driver ',
		dataIndex: 'driver_username',
		key: 'driver_username',
	},
	{
		title: 'Per Trip Cost',
		dataIndex: 'per_trip_cost',
		key: 'per_trip_cost',
	},
	{
		title: 'No of Trips',
		dataIndex: 'no_of_trips',
		key: 'no_of_trips',
	},
	{
		title: 'Amount',
		dataIndex: 'total_cost',
		key: 'total_cost',
	},
	{
		title: 'TDS Rate',
		dataIndex: 'tds_rate',
		key: 'tds_rate',
	},
	{
		// eslint-disable-next-line sonarjs/no-duplicate-string
		title: 'TDS Amount',
		dataIndex: 'tds_amount',
		key: 'tds_amount',
	},
];

const columnsAdhocTrip = [
	{
		title: 'Vehicle Type',
		dataIndex: 'vehicle_type',
		key: 'vehicle_type',
	},
	{
		title: 'Vehicle Rate',
		dataIndex: 'vehicle_rate',
		key: 'vehicle_rate',
	},
	{
		title: 'No Of Trips',
		dataIndex: 'no_of_trips',
		key: 'no_of_trips',
	},
	{
		title: 'Total Amount',
		dataIndex: 'total_cost',
		key: 'total_cost',
	},
	{
		title: 'TDS Rate',
		dataIndex: 'tds_rate',
		key: 'tds_rate',
	},
	{
		title: 'TDS Amount',
		dataIndex: 'tds_amount',
		key: 'tds_amount',
	},
];
const AdvancePaymentSource = [
	{
		title: 'Trip Id',
		dataIndex: 'trip_id',
		key: 'trip_id',
		render: (value) => value || '-',
	},
	{
		title: 'UTR Number',
		dataIndex: 'advance_utr_number',
		key: 'advance_utr_number',
		render: (value) => value || '-',
	},
	{
		title: 'Advance Amount',
		dataIndex: 'advance_amount',
		key: 'advance_amount',
		render: (value) => (value !== undefined && value !== null && value !== '' ? value : '-'),
	},
	{
		title: 'Proforma Invoice No',
		dataIndex: 'proforma_invoice_number',
		key: 'proforma_invoice_number',
		render: (value) => value || '-',
	},
	{
		title: 'Proforma PDF',
		dataIndex: 'proforma_pdf_url',
		key: 'proforma_pdf_url',
		render: (value) =>
			value ? (
				<span
					style={{ cursor: 'pointer', color: '#d32f2f', fontSize: '18px' }}
					title="View Proforma PDF"
					onClick={() => window.open(value, '_blank')}
					role="button"
					tabIndex={0}
					onKeyDown={(e) => e.key === 'Enter' && window.open(value, '_blank')}
				>
					📄
				</span>
			) : (
				'-'
			),
	},
];

const columnsNoLoadTrip = [
	{
		title: 'Driver',
		dataIndex: 'driver_username',
		key: 'driver_username',
	},
	{
		title: 'No Load Trip Charge',
		dataIndex: 'noload_trip_charge',
		key: 'noload_trip_charge',
	},
	{
		title: 'No Of Trips',
		dataIndex: 'no_of_trips',
		key: 'no_of_trips',
	},
	{
		title: 'Total Amount',
		dataIndex: 'total_cost',
		key: 'total_cost',
	},
	{
		title: 'TDS Rate',
		dataIndex: 'tds_rate',
		key: 'tds_rate',
	},
	{
		title: 'TDS Amount',
		dataIndex: 'tds_amount',
		key: 'tds_amount',
	},
];
const TitleText = styled(Text)`
	font-size: 26px;
	font-weight: 600;
	line-height: 50px;
	margin-bottom: 24px;
`;

const SubTitle = styled(Text)`
	font-size: 20px;
	font-weight: 400;
	line-height: 30px;
	margin-bottom: 16px;
`;

const Tag = styled(Text)`
	font-weight: 400;
	margin-right: 10px;
`;

const Card = styled(Box)`
	background-color: #fff;
	border-radius: 8px;
	border-top: 2px solid #2f8ecb;
	margin-bottom: 16px;
	padding: 24px;
`;

const Flex = styled(Box)`
	display: flex;
`;

const FlexChild = styled(Box)`
	flex-grow: 1;
	flex-basis: 50%;
	margin-right: 16px;
`;

// Export the styled components and table configurations
export {
	Container,
	StyledTabs,
	columnsRegularTrip,
	columnsAdhocTrip,
	AdvancePaymentSource,
	columnsNoLoadTrip,
	TitleText,
	SubTitle,
	Tag,
	Card,
	Flex,
	FlexChild,
};

export default function VendorInvoicePage() {
	const { id } = useParams();
	const dispatch = useDispatch();
	const uiVersion = getUIVersion();
	const useV2API = uiVersion === 'new';
	const [vendorBillRes, setVendorBillRes] = useState({});
	const [activeTab, setActiveTab] = useState('invoice-details');

	useEffect(() => {
		if (id) {
			const action = useV2API
				? getVendorBillDetailsV2({ id })
				: getClientList({
						search_type: 'vendor_bill_details',
						filter_by: {
							id,
						},
				  });

			dispatch(action).then((res) => {
				console.log('res', res);
				if (res) {
					setVendorBillRes(res.data);
				} else {
					setVendorBillRes({});
				}
			});
		}
	}, [dispatch, id, useV2API]);

	const handleTabChange = (key) => {
		setActiveTab(key);
	};

	const items = [
		{
			key: 'invoice-details',
			label: 'Invoice Details',
			children: (
				<InvoiceDetailsContent
					vendorBillRes={vendorBillRes}
					regularTripData={vendorBillRes?.regular_trips_bill || []}
					adhocTripData={vendorBillRes?.adhoc_trips_bill || []}
					noLoadTripData={vendorBillRes?.noload_trips_bill || []}
				/>
			),
		},
		{
			key: 'trips',
			label: 'Trips',
			children: <VendorBillTripsTab vendorBillId={id} />,
		},
	];

	return (
		<Container>
			<StyledTabs activeKey={activeTab} onChange={handleTabChange} items={items} />
		</Container>
	);
}
